import React, { useState } from 'react';
import { login } from '../services/api';
import './LoginPage.css';

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);
    
    setLoading(false);

    if (result.success) {
      onLogin(result.user);
    } else {
      setError(result.message || 'Identifiants incorrects');
    }
  };


  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img
            src="https://static.wixstatic.com/media/4a94e6_36d4e5d5d2ff410ebbab6f1a947fac88~mv2_d_1772_1772_s_2.png"
            alt="Ateliers du Château"
            className="login-logo"
          />
          <h1>Ateliers du Château</h1>
          <p>Système de gestion des commandes</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Nom d'utilisateur</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Entrez votre nom d'utilisateur"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Entrez votre mot de passe"
              required
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
